import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const TextLength = styled.span`
  display: inline-block;
  flex-shrink: 0;
  ${TYPOGRAPHY.body}
  color: #fff;
  opacity: 0.6;
`;

export default TextLength;
